export const STATUS_ID = {
    requestReceived: 1,
    inProcess: 2,
    error: 3,
    responseReceived: 4,
    responseTransferred: 5,
    completed: 6
}
export const RECORD_STATUS = {
    total: { statusIds: [], title: 'All records' },
    inProgress: {
        statusIds: [STATUS_ID.requestReceived, STATUS_ID.inProcess, STATUS_ID.responseReceived, STATUS_ID.responseTransferred],
        title: 'In progress records'
    },
    requestReceived: { statusIds: [STATUS_ID.requestReceived], title: 'Request received records' },
    inProcess: { statusIds: [STATUS_ID.inProcess], title: 'In process records' },
    responseReceived: { statusIds: [STATUS_ID.responseReceived], title: 'Response received records' },
    responseTransferred: { statusIds: [STATUS_ID.responseTransferred], title: 'Response transferred records' },
    error: { statusIds: [STATUS_ID.error], title: 'Failed records' },
    completed: { statusIds: [STATUS_ID.completed], title: 'Completed records' }
}
export const recordStatusFor = (key) => RECORD_STATUS[key] || RECORD_STATUS.total
export const DIRECTION = {
    source: { key: 'source', requestType: 'Source' },
    target: { key: 'target', requestType: 'Target' }
}
export const directionFor = (key) => (key === 'target' ? DIRECTION.target : DIRECTION.source)
export const endpointIdFor = (connection, direction) => direction.key === 'target' ? connection.target.id : connection.source.id
